import type { ReactNode } from 'react';

import styles from './HeadlineStats.scss';

type HeadlineStatsProps = {
  stats: {
    stat: string;
    subtitle: ReactNode;
  }[];
};

export const HeadlineStats = ({
  stats,
}: HeadlineStatsProps) => <ul className={styles.stats}>
  {stats.map(({ stat, subtitle }) => (<li key={stat} className={styles.stat}>
    <h3>{stat}</h3>
    <p data-thc-style-override>{subtitle}</p>
  </li>))}
</ul>;
